import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue";
var _hoisted_1 = { class: "md-editor-outter-container flex-center" };
var _hoisted_2 = {
    key: 0,
    style: { "--js-options-group-height": "160.7px" },
    class: "md-editor-optons-container"
};
var _hoisted_3 = { class: "md-editor-optons-rows" };
var _hoisted_4 = { class: "editor-optons-row" };
var _hoisted_5 = { class: "editor-optons-row" };
var _hoisted_6 = { class: "editor-optons-row" };
var _hoisted_7 = { class: "editor-optons-cover-edit" };
var _hoisted_8 = { class: "md-editor-left-nav usn" };
var _hoisted_9 = { class: "md-editor-aside-tool-bar" };
import { onBeforeUnmount, onMounted, ref, watch, computed, render, h, } from "vue";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import { useStore } from "@/store";
import { NormalToolbar, MdEditor, config, } from "md-editor-v3";
import { generateDiffPatch } from "@/views/md-editor/mdEditCore";
import CategorySelector from "@/components/MdEditAbout/CategorySelector.vue";
import TagSelector from "@/components/MdEditAbout/TagSelector.vue";
import MdEditorCoverUploader from "@/components/MdEditAbout/MdEditorCoverUploader.vue";
import PostRefSelect from "@/components/MdEditAbout/PostRefSelect.vue";
import CustomSVG from "@/components/custom/CustomSVG.vue";
import PhraseSelectModal from "@/components/MdEditAbout/PhraseSelectModal.vue";
import "md-editor-v3/lib/style.css"; // MD 引入样式，否则主题无效!!!!!!!>sp
import { NConfigProvider, NDropdown, NInput } from "naive-ui";
import JSZip from "jszip";
// @ts-ignore // 下载了 spark-md5 的类型文件了，但仍然时不时报错，怪
import SparkMD5 from "spark-md5";
import { phraseTypes, processMdContent } from "@/utils/phrase";
// import funcs from "@/commonFunctions";
import api from "@/utils/api";
import tools from "@/utils/tools";
/// /modifydraftmeta
var asideIconSize = 22;
var inputStopUploadTime = 1000; // meta 输入防抖，在输入指定该时间后也仍然没有输入，则进行上传
var mdContentSaveToggleTime = 3500; // 草稿内容保存定时，3.5s 保存一次
export default /*@__PURE__*/ _defineComponent({
    __name: 'PostMdEditor',
    setup: function (__props) {
        var _this = this;
        var mdEditorRef = ref();
        var store = useStore();
        var route = useRoute();
        var router = useRouter();
        var isShowPhraseModal = ref(false), phraseType = ref(phraseTypes[0].value), selectedPhrase = ref(null);
        var uuid = String(route.query.uuid);
        window.resourceBaseUrl = "https://".concat(window.location.host, "/draft/").concat(uuid);
        var seq = 0;
        var mdContent = ref("");
        var passMdContent = "";
        var saveMutex = tools.newMutex(); // saveMutex: 保存阻塞锁，确保仅有一个创建diff与保存的操作在进行中，避免乱序diff与非法seq出现
        var mdContentSaveToggleTimer = undefined;
        var titleInputTimeout = undefined, categoryInputTimeout = undefined, tagsInputTimeout = undefined;
        var hasImg = ref(false), isCoverImgLoaded = ref(false);
        var isDraftAlreadyRelease = false; // 是否已发布草稿，用于确保在发布导致该页面卸载时不会再次保存已经发布的草稿
        var postDraft = ref({
            draftID: "",
            title: "",
            category: "",
            tags: [],
            cover: "",
            lastUpdateTime: "2025-02-01 11:45:14",
            isRelease: false,
            id: -1,
        });
        var postDraftCoverFile = ref(null);
        store.setPageName("草稿编辑模式");
        api.request
            .get("/getdraft?draftID=".concat(uuid))
            .then(function (res) {
            var resp = res;
            postDraft.value = res.data.meta;
            seq = res.data.seq;
            console.log("草稿数据: ", postDraft.value);
            console.log("草稿数据 seq: ", seq);
            // 草稿封面赋值
            if (postDraft.value.cover) {
                hasImg.value = true;
                isCoverImgLoaded.value = false;
                store.establishSmallLoadConnection();
                api.requestBase
                    .getfile("/draft/".concat(uuid, "/").concat(postDraft.value.cover))
                    .then(function (res) {
                    postDraftCoverFile.value = new File([res.data], postDraft.value.cover);
                    isCoverImgLoaded.value = true;
                })
                    .catch(function (error) {
                    window.$notifyError("获取草稿封面失败", error);
                })
                    .finally(function () {
                    store.finishSmallLoadConnection();
                });
            }
            store.setPageName("\u8349\u7A3F\u7F16\u8F91\u6A21\u5F0F - ".concat(postDraft.value.title, " - ").concat(uuid));
            // 奇怪的 vue，监听个对象加 { deep: true } 也就算了，oldVal 和 newVal 还能一样的（如果不是整个对象修改的话
            // watch(
            //   () => postDraft.value,
            //   (newVal, oldVal) => {
            //     console.log("草稿数据变化: ", newVal);
            //     if (newVal.category !== oldVal.category) {
            //       updateMeta("category");
            //     } else if (newVal.tags !== oldVal.tags) {
            //       updateMeta("tags");
            //     } else if (newVal.title !== oldVal.title) {
            //       console.log("title change");
            //       updateMeta("title");
            //       store.setPageName(`草稿编辑模式 - ${newVal} - ${uuid}`);
            //     } else {
            //       console.log("草稿数据变化??", newVal, oldVal);
            //     }
            //   },
            //   { deep: true } // 深度监听，在监听对象时必须要加上这个选项，否则失效
            // );
            watch(function () { return postDraft.value.category; }, function (newVal, oldVal) {
                console.log("category change", newVal, oldVal);
                updateMeta("category");
            });
            watch(function () { return postDraft.value.tags; }, function (newVal, oldVal) {
                console.log("tags change", newVal, oldVal);
                updateMeta("tags");
            });
            watch(function () { return postDraft.value.title; }, function (newVal, oldVal) {
                console.log("title change", newVal, oldVal);
                store.setPageName("\u8349\u7A3F\u7F16\u8F91\u6A21\u5F0F - ".concat(newVal, " - ").concat(uuid));
                if (!newVal) {
                    window.$msgError("草稿标题不能为空");
                    return;
                }
                updateMeta("title");
            });
        })
            .catch(function (error) {
            window.$notifyError("获取草稿失败", error);
            isCoverImgLoaded.value = true;
        });
        api.requestBaseWithMask
            .get("/draft/".concat(uuid, "/markdown.md?t=").concat(Date.now()))
            .then(function (res) {
            // dos 系统（windows）换行符为 \r\n，统一改为 linux 系统换行符为 \n，否则会报错
            // mdContent.value = String(res.data).replace(/\r\n/g, "\n");
            mdContent.value = String(res.data);
            passMdContent = mdContent.value;
            watch(function () { return mdContent.value; }, function (newVal) {
                // 发生变更就重置定时器，直到最后一次更改后指定时间内还没有修改就保存
                clearTimeout(mdContentSaveToggleTimer);
                mdContentSaveToggleTimer = setTimeout(function () {
                    saveMdContentFunc();
                    clearTimeout(mdContentSaveToggleTimer);
                }, mdContentSaveToggleTime);
            });
        })
            .catch(function (error) {
            window.$notifyError("获取草稿正文失败", error.message);
        });
        var toggleMdOptionsFold = function () {
            store.setIsMdMetaColumnFold(!store.isMdMetaColumnFold);
        };
        var setOptionsHeightToCssVar = function () {
            var optionsContainer = document.querySelector(".md-editor-optons-container");
            if (optionsContainer) {
                var height = optionsContainer.offsetHeight;
                optionsContainer.style.setProperty("--js-options-group-height", "".concat(height, "px"));
            }
        };
        var mdEditorContainer = ref(undefined);
        config({
            markdownItPlugins: function (plugins) {
                return plugins.filter(function (p) { return p.type !== "xss"; });
            },
        });
        var mdHeadingId = function (text, _level, index) {
            return "heading-".concat(text, "-").concat(index);
        };
        // 草稿 meta 数据修改后的接受值，type 为修改的属性（不接受 cover，因为已经在上面那一处监听），value 为修改后的值，类型为 PostDraftItem 对应的传入键的值的类型
        var updateMetaData = function (type, value) { return __awaiter(_this, void 0, Promise, function () {
            var formData;
            return __generator(this, function (_a) {
                if (!value)
                    return [2 /*return*/, Promise.resolve()];
                formData = new FormData();
                formData.append("draftID", uuid);
                formData.append("type", type);
                formData.append("value", Array.isArray(value) ? JSON.stringify(value) : value);
                return [2 /*return*/, api.requestWithSmallLoad
                        .quickPost("/modifydraftmeta", formData)
                        .then(function (res) {
                        var resp = res;
                        if (resp.code !== 0) {
                            window.$msgError("修改草稿失败: " + resp.msg);
                            return;
                        }
                        else {
                            if (type === "cover") {
                                if (!(value instanceof File)) {
                                    window.$msgError("草稿封面值不为文件");
                                    return;
                                }
                                postDraft.value.cover = value.name;
                            }
                            else {
                                postDraft.value[type] = value;
                            }
                            postDraft.value.lastUpdateTime = new Date().toLocaleString();
                        }
                    })
                        .catch(function (error) {
                        window.$msgError("更新元数据失败");
                        return Promise.reject(error); // 传递错误
                    })];
            });
        }); };
        var updateMeta = function (field) {
            if (field === "title") {
                clearTimeout(titleInputTimeout);
                titleInputTimeout = setTimeout(function () {
                    updateMetaData(field, postDraft.value[field]);
                }, inputStopUploadTime);
            }
            else if (field === "category") {
                clearTimeout(categoryInputTimeout);
                categoryInputTimeout = setTimeout(function () {
                    updateMetaData(field, postDraft.value[field]);
                }, inputStopUploadTime);
            }
            else if (field === "tags") {
                clearTimeout(tagsInputTimeout);
                tagsInputTimeout = setTimeout(function () {
                    updateMetaData(field, postDraft.value[field]);
                }, inputStopUploadTime);
            }
            else if (field === "cover") {
                if (!postDraftCoverFile.value) {
                    window.$msgError("草稿封面文件不存在");
                    return;
                }
                updateMetaData(field, postDraftCoverFile.value);
            }
            else {
                console.error("[updateMeta] 不支持的字段类型");
            }
        };
        var handleCoverFileChange = function (file) {
            postDraftCoverFile.value = file;
            updateMeta("cover");
        };
        // 上传md编辑的图片 (files: Array<File>, callBack: UploadImgCallBack) => void
        // export type UploadImgCallBackParam = string[] | Array<{
        //     url: string;
        //     alt: string;
        //     title: string;
        // }>;
        // export type UploadImgCallBack = (urls: UploadImgCallBackParam) => void;
        // export type UploadImgEvent = (files: Array<File>, callBack: UploadImgCallBack) => void;
        var uploadIMG = function (files, callback) { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(files.map(function (file) {
                            return new Promise(function (rev, rej) {
                                var form = new FormData();
                                form.append("file", file);
                                form.append("draftID", uuid);
                                form.append("isMultipleFiles", "false");
                                // funcs.requestWithoutMask
                                //   .post(`/uploadIMG?type=${editType}&&uuid=${uuid}`, form, {
                                //     headers: {
                                //       "Content-Type": "multipart/form-data",
                                //     },
                                //   })
                                //   .then((res) => rev(res))
                                //   .catch((error) => rej(error));
                                api.requestWithSmallLoad
                                    .quickPost("/uploaddraftfile", form)
                                    .then(function (res) { return rev(res); })
                                    .catch(function (error) {
                                    window.$notifyError("上传图片失败", error);
                                    rej(res);
                                });
                            });
                        }))];
                    case 1:
                        res = _a.sent();
                        postDraft.value.lastUpdateTime = new Date().toLocaleString();
                        callback(res
                            .filter(function (item) {
                            console.log("callback filter", item);
                            var resp = item;
                            if (resp.code !== 0) {
                                window.$msgError("上传图片失败: " + resp.msg);
                            }
                            return resp.code === 0;
                        })
                            ///////////////////////////////////////////////////////////////////////////////////////////////////
                            .map(function (item) {
                            // 文件名有可能被修改（在存在重名文件时），使用服务器返回的文件名
                            return "\n\uFFE5\uFFE5\\/RESOURCE_BASE\\/\uFFE5\uFFE5/".concat(encodeURIComponent(item.data), "\n");
                        }));
                        return [2 /*return*/];
                }
            });
        }); };
        // function generateDiffPatch(text1: string, text2: string) {
        //   // 计算文本之间的差异（按行计算）
        //   const diffs = diffChars(text1, text2);
        //   console.log("diffs", diffs);
        //   const charPatch = [] as MdDrafDiff[];
        //   let startIndex = 0,
        //     endIndex = 0;
        //   let diffContent = "";
        //   let isClearPart = true;
        //   diffs.forEach((part) => {
        //     if (part.removed) {
        //       isClearPart = false;
        //       endIndex += part.count || 0;
        //     } else if (part.added) {
        //       isClearPart = false;
        //       diffContent = part.value;
        //     } else {
        //       // 到达统一位置以上完成一个块修改
        //       if (!isClearPart) {
        //         charPatch.push({
        //           start: startIndex,
        //           end: endIndex,
        //           diffContent: diffContent,
        //         });
        //       }
        //       isClearPart = true;
        //       endIndex += part.count || 0;
        //       startIndex = endIndex;
        //       diffContent = "";
        //     }
        //   });
        //   if (!isClearPart) {
        //     // 处理在added和removed均为false的情况后的最后一块差异
        //     charPatch.push({
        //       start: startIndex,
        //       end: endIndex,
        //       diffContent: diffContent,
        //     });
        //   }
        //   return charPatch;
        // }
        function saveContentDiff(diff, mdSnapshot, isNeedMask) {
            if (isNeedMask === void 0) { isNeedMask = false; }
            return __awaiter(this, void 0, void 0, function () {
                var requestFunc, formData;
                return __generator(this, function (_a) {
                    requestFunc = isNeedMask ? api.request : api.requestWithSmallLoad;
                    formData = new FormData();
                    formData.append("draftID", uuid);
                    formData.append("diff", JSON.stringify(diff));
                    formData.append("seq", String(++seq));
                    return [2 /*return*/, requestFunc
                            .quickPost("/modifydraftcontent", formData)
                            .then(function (res) {
                            var resp = res;
                            if (resp.data.hash !== SparkMD5.hash(mdSnapshot)) {
                                window.$notifyWarning("草稿内容与服务器不一致 Σ(ﾟДﾟ；≡；ﾟдﾟ)", "神秘力量导致只能强制保存统一数据了");
                                console.error("草稿内容与服务器不一致，md5 不匹配");
                                console.log("保存草稿响应: ", resp.data);
                                console.log("md5: ", SparkMD5.hash(mdSnapshot));
                                console.log("diff\n", diff, "passMdContent:\n", passMdContent, "mdContent snapshot:\n", mdSnapshot);
                            }
                            // if (resp.data) passMdContent = mdContent.value; // 更新历史草稿内容
                            if (resp.data)
                                passMdContent = mdSnapshot; // 修复，防止在请求过程中如果出现输入时这个输入不会统一到服务端，导致后续修改不一致
                            postDraft.value.lastUpdateTime = new Date().toLocaleString();
                            return;
                        })
                            .catch(function (error) {
                            window.$msgError("保存草稿失败: " +
                                error.response.msg +
                                "，如果是 seq 不一致请手动强制保存后刷新重试");
                            console.error("保存草稿失败: ", error);
                            console.log("保存草稿失败，seq: ", seq);
                            console.log("保存草稿失败，passContent: ", passMdContent);
                            console.log("保存草稿失败，草稿内容: ", mdContent.value);
                            console.log("保存草稿失败，diff: ", JSON.stringify(diff));
                            // tools.reflash(); // 别刷新，给自己手动保存的时间
                        })];
                });
            });
        }
        var saveMdContentFunc = function (isNeedMask) {
            if (isNeedMask === void 0) { isNeedMask = false; }
            return __awaiter(_this, void 0, void 0, function () {
                var diff;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, saveMutex.lock()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, , 5, 6]);
                            if (!(mdContent.value != passMdContent)) return [3 /*break*/, 4];
                            diff = generateDiffPatch(passMdContent, mdContent.value);
                            if (!diff) {
                                console.log("草稿内容没有变化或解析出现问题，不保存");
                                window.$msgInfo("草稿内容解析可能出现问题");
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, saveContentDiff(diff, mdContent.value, isNeedMask)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            saveMutex.unlock();
                            return [7 /*endfinally*/];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        var saveAllMetaData = function () { return __awaiter(_this, void 0, void 0, function () {
            var forceSaveField;
            return __generator(this, function (_a) {
                forceSaveField = ["title", "category", "tags"];
                return [2 /*return*/, Promise.all(forceSaveField.map(function (field) {
                        return updateMetaData(field, postDraft.value[field]);
                    }))];
            });
        }); };
        // 手动保存，去除自动保存 timer，保证手动保存时不会触发自动保存影响 seq 次序
        var saveDraft = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clearInterval(mdContentSaveToggleTimer); // 清除本次修改触发的自动保存定时器，本次修改已启用手动保存
                        mdContentSaveToggleTimer = undefined;
                        return [4 /*yield*/, saveAllMetaData()];
                    case 1:
                        _a.sent(); // 防止发布时没有保存完草稿元数据
                        return [4 /*yield*/, saveMdContentFunc(true)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var forceSave = function () { return __awaiter(_this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, saveMutex.lock()];
                    case 1:
                        _a.sent();
                        console.log("force save");
                        clearInterval(mdContentSaveToggleTimer); // 清除本次修改触发的自动保存定时器，本次修改已启用手动保存
                        mdContentSaveToggleTimer = undefined;
                        formData = new FormData();
                        formData.append("draftID", uuid);
                        formData.append("content", mdContent.value.replaceAll("\r\n", "\n"));
                        api.request
                            .quickPost("/forcesave", formData)
                            .then(function (res) {
                            var resp = res;
                            if (resp.code !== 0) {
                                window.$msgError("强制保存草稿失败: " + resp.msg);
                            }
                            else {
                                window.$msgSuccess("强制保存草稿成功");
                            }
                        })
                            .finally(function () {
                            saveMutex.unlock();
                        });
                        saveAllMetaData();
                        return [2 /*return*/];
                }
            });
        }); };
        var releasePost = function () { return __awaiter(_this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (postDraft.value.title === "" ||
                            postDraft.value.category === "" ||
                            postDraft.value.tags === null ||
                            postDraft.value.tags.length === 0 ||
                            postDraft.value.cover === "" ||
                            postDraftCoverFile.value === undefined) {
                            window.$msgError("草稿元数据不完整，检查标题、分类、标签、封面是否填写完整");
                            return [2 /*return*/];
                        }
                        console.log("release post");
                        // 先全部保存一遍再发布
                        return [4 /*yield*/, saveDraft()];
                    case 1:
                        // 先全部保存一遍再发布
                        _a.sent();
                        formData = new FormData();
                        formData.append("draftID", uuid);
                        api.request
                            .quickPost("/releasedraft", formData)
                            .then(function (res) {
                            window.$notifySuccess("发布草稿成功", "\u8349\u7A3F ".concat(postDraft.value.title, " \u5DF2\u53D1\u5E03\u3002\u53D1\u5E03\u65F6\u95F4\uFF1A").concat(new Date().toLocaleString()));
                            isDraftAlreadyRelease = true; // 发布成功后设置为 true
                            router.push("/"); // 发布成功后跳转到首页
                        })
                            .catch(function (error) {
                            window.$notifyError("发布草稿失败", error.response.msg);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        // 第一个参数为传入给 CustomSVG 的 icon 名称，第二个参数为 tooltip 的 title，第三个参数为点击事件
        function addMdEditorToolbarOption(customSVGIconName, title, containerElement) {
            var mdToolbars = document.querySelector(".md-editor-toolbar-left");
            if (mdToolbars) {
                var vnode = h(CustomSVG, {
                    icon: customSVGIconName,
                    class: ["lucide", "lucide-save-icon", "md-editor-icon"],
                });
                var container = containerElement;
                // container.className = "md-editor-toolbar-item";
                container.classList.add("md-editor-toolbar-item");
                container.title = title;
                render(vnode, container); // 将 h 的 vnode 渲染到 container
                mdToolbars.appendChild(container);
            }
        }
        var insertTextToEditor = function (text) {
            if (mdEditorRef.value) {
                mdEditorRef.value.insert(function (_) {
                    return {
                        targetValue: text,
                        select: false,
                        deviationStart: 0,
                        deviationEnd: 0,
                    };
                });
            }
        };
        // 选择文章引用使用
        var postOptions = ref([]);
        var postOptionsComputed = computed(function () {
            return postOptions.value;
        });
        api.requestWithSmallLoad
            .get("/postlist")
            .then(function (res) {
            var resp = res;
            postOptions.value = resp.data.map(function (post) {
                return {
                    label: post.title,
                    key: post.id,
                };
            });
            window.PostRefUsePostList = resp.data;
        })
            .catch(function (error) {
            var msg = error.response.msg;
            window.$notifyError("获取文章列表失败", msg);
        });
        function handlePostRefSelect(selectedRefPostID) {
            console.log("handlePostRefSelect", selectedRefPostID);
            var post = window.PostRefUsePostList.find(function (post) { return post.id === selectedRefPostID; });
            if (post) {
                insertTextToEditor("\n\uFFE5\uFFE5\\/UNIQUE_VAL_POST_REF_".concat(post.id, "\\/\uFFE5\uFFE5\n"));
            }
            else {
                window.$notifyError("文章引用错误", "文章不存在");
            }
        }
        /// onMounted 会使用到的虚拟节点
        onMounted(function () {
            // ------------------------------------------------------------------------
            // 上传文件或文件夹
            function uploadFileOrDir(file, isMultipleFiles) {
                var formData = new FormData();
                formData.append("draftID", uuid);
                formData.append("file", file);
                formData.append("isMultipleFiles", String(isMultipleFiles));
                api.request
                    .quickPost("/uploaddraftfile", formData)
                    .then(function (res) {
                    if (isMultipleFiles) {
                        var resp = res;
                        window.$notifySuccess("上传文件成功", "\u6587\u4EF6\u5DF2\u4E0A\u4F20\u3002\u6587\u4EF6\u5217\u8868\uFF1A\n".concat(resp.data.join(", ")));
                        insertTextToEditor("\n" +
                            resp.data
                                .map(function (fileName) {
                                return "\uFFE5\uFFE5\\/RESOURCE_BASE\\/\uFFE5\uFFE5/".concat(encodeURIComponent(fileName));
                            })
                                .join("\n") +
                            "\n");
                    }
                    else {
                        var resp = res;
                        window.$notifySuccess("上传文件成功", "\u6587\u4EF6\u5DF2\u4E0A\u4F20\u3002\u6587\u4EF6\u540D\uFF1A".concat(resp.data));
                        insertTextToEditor("\n\uFFE5\uFFE5\\/RESOURCE_BASE\\/\uFFE5\uFFE5/".concat(encodeURIComponent(resp.data), "\n"));
                    }
                })
                    .catch(function (error) {
                    window.$notifyError("上传文件失败", error);
                });
            }
            // // ------------------------------------------------------------------------
            // // 阻止页面刷新
            // window.addEventListener("beforeunload", (event) => {
            //   event.preventDefault();
            //   event.returnValue = "";
            // });
            var quickInputBtn = document.createElement("div");
            quickInputBtn.onclick = function () {
                isShowPhraseModal.value = true;
            };
            addMdEditorToolbarOption("QuickEdit", "快捷输入", quickInputBtn);
            // 触发选择文件的 input 标签，仅取其功能，不需要挂载到 DOM 上
            var uploadFileOrDirInput = document.createElement("input");
            uploadFileOrDirInput.type = "file";
            uploadFileOrDirInput.webkitdirectory = false; // 支持文件夹上传
            uploadFileOrDirInput.multiple = true; // 支持多文件上传
            uploadFileOrDirInput.oninput = function (e) { return __awaiter(_this, void 0, void 0, function () {
                var target, files, isFolder, zip, topLevelDir, _i, _a, file, relativePath, content, zipBlob, zipFile;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            target = e.target;
                            files = target.files;
                            if (!files || files.length === 0)
                                return [2 /*return*/];
                            isFolder = Array.from(files).some(function (f) { return f.webkitRelativePath; });
                            if (!isFolder && files.length === 1) {
                                // 单个文件，直接上传
                                uploadFileOrDir(files[0], false);
                                return [2 /*return*/];
                            }
                            zip = new JSZip();
                            topLevelDir = "";
                            _i = 0, _a = Array.from(files);
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            file = _a[_i];
                            relativePath = file.webkitRelativePath || file.name;
                            if (!topLevelDir)
                                topLevelDir = relativePath.split("/")[0]; // 保留顶级文件夹名
                            return [4 /*yield*/, file.arrayBuffer()];
                        case 2:
                            content = _b.sent();
                            zip.file(relativePath, content);
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [4 /*yield*/, zip.generateAsync({ type: "blob" })];
                        case 5:
                            zipBlob = _b.sent();
                            zipFile = new File([zipBlob], "".concat(topLevelDir || "archive", ".zip"), {
                                type: "application/zip",
                            });
                            uploadFileOrDir(zipFile, true);
                            return [2 /*return*/];
                    }
                });
            }); };
            var uploadFileClickDiv = document.createElement("div");
            uploadFileClickDiv.onclick = function () {
                uploadFileOrDirInput.click();
            };
            var mdToolbars = document.querySelector(".md-editor-toolbar-left");
            var fileDropdownVNode = h(NDropdown, {
                options: [
                    {
                        label: "选择文件",
                        key: "selectFile",
                    },
                    {
                        label: "选择文件夹",
                        key: "selectFolder",
                    },
                ],
                placement: "bottom",
                trigger: "hover",
                size: "small",
                onSelect: function (key) {
                    if (key === "selectFile") {
                        uploadFileOrDirInput.webkitdirectory = false; // 取消文件夹上传
                    }
                    else if (key === "selectFolder") {
                        uploadFileOrDirInput.webkitdirectory = true; // 支持文件夹上传
                    }
                    uploadFileOrDirInput.click();
                },
            }, {
                default: function () {
                    return h("div", {
                        class: "md-editor-toolbar-item",
                        title: "上传文件或文件夹",
                    }, [
                        h(CustomSVG, {
                            icon: "FileUpload",
                            class: ["lucide", "lucide-save-icon", "md-editor-icon"],
                        }),
                    ]);
                },
            });
            if (mdToolbars) {
                render(fileDropdownVNode, uploadFileClickDiv);
                mdToolbars.appendChild(uploadFileClickDiv);
            }
            // 选择文章引用
            if (mdToolbars) {
                var postRefSelectVNode = h(NConfigProvider, {
                    theme: window.naiveUITheme.value,
                    themeOverrides: window.themeOverrides.value,
                }, {
                    default: function () {
                        return h(PostRefSelect, {
                            posts: postOptionsComputed,
                            handleSelect: handlePostRefSelect,
                        });
                    },
                });
                render(postRefSelectVNode, mdToolbars);
            }
        });
        onBeforeUnmount(function () {
            // 清除定时器
            clearTimeout(mdContentSaveToggleTimer);
            clearTimeout(titleInputTimeout);
            clearTimeout(categoryInputTimeout);
            clearTimeout(tagsInputTimeout);
            if (!isDraftAlreadyRelease)
                saveDraft();
        });
        var editorOnSave = function (v, h) {
            forceSave();
        };
        var editorOnError = function (e) {
            console.error("editor error", e);
            window.$notifyError("\u7F16\u8F91\u5668\u5185\u90E8\u9519\u8BEF: ".concat(e.name), e.message);
        };
        var handlePhraseConfirm = function (phrase) {
            if (mdEditorRef.value) {
                mdEditorRef.value.insert(function (_) {
                    /**
                     * @return targetValue    待插入内容
                     * @return select         插入后是否自动选中内容，默认：true
                     * @return deviationStart 插入后选中内容鼠标开始位置，默认：0
                     * @return deviationEnd   插入后选中内容鼠标结束位置，默认：0
                     */
                    return {
                        targetValue: "".concat(phrase),
                        select: false,
                        deviationStart: 0,
                        deviationEnd: 0,
                    };
                });
            }
        };
        return function (_ctx, _cache) {
            var _component_n_icon = _resolveComponent("n-icon");
            var _component_n_tooltip = _resolveComponent("n-tooltip");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: "md-editor-container flex-center",
                        ref_key: "mdEditorContainer",
                        ref: mdEditorContainer
                    }, [
                        _createVNode(_Transition, {
                            name: "md-editor-options-transition",
                            onBeforeEnter: setOptionsHeightToCssVar,
                            onBeforeLeave: setOptionsHeightToCssVar
                        }, {
                            default: _withCtx(function () { return [
                                (!_unref(store).isMdMetaColumnFold)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                        _createElementVNode("div", _hoisted_3, [
                                            _createElementVNode("div", _hoisted_4, [
                                                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "edit-option-title" }, " 标题 ", -1)),
                                                _createVNode(_unref(NInput), {
                                                    class: "edit-option-content",
                                                    value: postDraft.value.title,
                                                    "onUpdate:value": _cache[0] || (_cache[0] = function ($event) { return ((postDraft.value.title) = $event); }),
                                                    placeholder: "文章标题",
                                                    size: "large"
                                                }, null, 8, ["value"])
                                            ]),
                                            _createElementVNode("div", _hoisted_5, [
                                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "edit-option-title" }, " 分类 ", -1)),
                                                _createVNode(CategorySelector, {
                                                    class: "edit-option-content",
                                                    "bind-value": postDraft.value.category,
                                                    "onUpdate:bindValue": _cache[1] || (_cache[1] = function ($event) { return ((postDraft.value.category) = $event); })
                                                }, null, 8, ["bind-value"])
                                            ]),
                                            _createElementVNode("div", _hoisted_6, [
                                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "edit-option-title" }, " 标签 ", -1)),
                                                _createVNode(TagSelector, {
                                                    class: "edit-option-content",
                                                    "bind-value": postDraft.value.tags,
                                                    "onUpdate:bindValue": _cache[2] || (_cache[2] = function ($event) { return ((postDraft.value.tags) = $event); })
                                                }, null, 8, ["bind-value"])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_7, [
                                            _createVNode(MdEditorCoverUploader, {
                                                modelValue: postDraftCoverFile.value,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((postDraftCoverFile).value = $event); }),
                                                onUpload: handleCoverFileChange,
                                                "has-img": _unref(hasImg),
                                                "is-loaded": _unref(isCoverImgLoaded)
                                            }, null, 8, ["modelValue", "has-img", "is-loaded"])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]; }),
                            _: 1
                        }),
                        _createVNode(_unref(MdEditor), {
                            class: "md-editor",
                            modelValue: mdContent.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((mdContent).value = $event); }),
                            onUploadImg: uploadIMG,
                            onOnSave: editorOnSave,
                            onOnError: editorOnError,
                            "process-content": _unref(processMdContent),
                            theme: _unref(store).isDarkTheme ? 'dark' : 'light',
                            autoFoldThreshold: 80,
                            placeholder: "创造从此刻开始...",
                            toolbarsExclude: ['github'],
                            ref_key: "mdEditorRef",
                            ref: mdEditorRef,
                            mdHeadingId: mdHeadingId
                        }, {
                            defToolbars: _withCtx(function () { return [
                                _createVNode(_unref(NormalToolbar), {
                                    title: "快捷输入",
                                    onOnClick: _cache[4] || (_cache[4] = function ($event) { return (isShowPhraseModal.value = true); })
                                }, {
                                    trigger: _withCtx(function () { return [
                                        _createVNode(CustomSVG, { icon: "QuickEdit" })
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        }, 8, ["modelValue", "process-content", "theme"])
                    ], 512)
                ]),
                _createElementVNode("aside", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_n_tooltip, {
                            trigger: "hover",
                            placement: "right"
                        }, {
                            trigger: _withCtx(function () { return [
                                _createElementVNode("div", {
                                    class: "md-editor-aside-icon",
                                    onClick: toggleMdOptionsFold
                                }, [
                                    _createVNode(_component_n_icon, {
                                        size: asideIconSize,
                                        class: "md-editor-aside-icon"
                                    }, {
                                        default: _withCtx(function () { return [
                                            (_unref(store).isMdMetaColumnFold)
                                                ? (_openBlock(), _createBlock(CustomSVG, {
                                                    key: 0,
                                                    icon: "CubeDash",
                                                    class: "md-editor-aside-icon-fa"
                                                }))
                                                : (_openBlock(), _createBlock(CustomSVG, {
                                                    key: 1,
                                                    icon: "Cube",
                                                    class: "md-editor-aside-icon-fa"
                                                }))
                                        ]; }),
                                        _: 1
                                    })
                                ])
                            ]; }),
                            default: _withCtx(function () { return [
                                _createTextVNode(" " + _toDisplayString("".concat(_unref(store).isMdMetaColumnFold ? "展开" : "收起", "\u5143\u6570\u636E\u7F16\u8F91")), 1)
                            ]; }),
                            _: 1
                        }),
                        _createVNode(_component_n_tooltip, {
                            trigger: "hover",
                            placement: "right"
                        }, {
                            trigger: _withCtx(function () { return [
                                _createElementVNode("div", {
                                    class: "md-editor-aside-icon",
                                    onClick: saveDraft
                                }, [
                                    _createVNode(_component_n_icon, { size: asideIconSize }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(CustomSVG, {
                                                icon: "Save",
                                                class: "md-editor-aside-icon-fa"
                                            })
                                        ]; }),
                                        _: 1
                                    })
                                ])
                            ]; }),
                            default: _withCtx(function () { return [
                                _cache[12] || (_cache[12] = _createTextVNode(" 手动保存 "))
                            ]; }),
                            _: 1
                        }),
                        _createVNode(_component_n_tooltip, {
                            trigger: "hover",
                            placement: "right"
                        }, {
                            trigger: _withCtx(function () { return [
                                _createElementVNode("div", {
                                    class: "md-editor-aside-icon",
                                    onClick: forceSave
                                }, [
                                    _createVNode(_component_n_icon, { size: asideIconSize }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(CustomSVG, {
                                                icon: "ForceSave",
                                                class: "md-editor-aside-icon-fa"
                                            })
                                        ]; }),
                                        _: 1
                                    })
                                ])
                            ]; }),
                            default: _withCtx(function () { return [
                                _cache[13] || (_cache[13] = _createTextVNode(" 强制统一数据 "))
                            ]; }),
                            _: 1
                        }),
                        _createVNode(_component_n_tooltip, {
                            trigger: "hover",
                            placement: "right"
                        }, {
                            trigger: _withCtx(function () { return [
                                _createElementVNode("div", {
                                    class: "md-editor-aside-icon",
                                    onClick: releasePost
                                }, [
                                    _createVNode(_component_n_icon, { size: asideIconSize }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(CustomSVG, {
                                                icon: "AddTaskOutlined",
                                                class: "md-editor-aside-icon-fa"
                                            })
                                        ]; }),
                                        _: 1
                                    })
                                ])
                            ]; }),
                            default: _withCtx(function () { return [
                                _cache[14] || (_cache[14] = _createTextVNode(" 发布 "))
                            ]; }),
                            _: 1
                        })
                    ]),
                    _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"title-bar\" data-v-7de32f92><div class=\"stripes\" data-v-7de32f92><div class=\"stripe\" data-v-7de32f92></div><div class=\"stripe\" data-v-7de32f92></div></div><span class=\"side-bar-title\" data-v-7de32f92>Console Post Editor</span></div>", 1))
                ]),
                _createVNode(PhraseSelectModal, {
                    "is-show-modal": isShowPhraseModal.value,
                    "onUpdate:isShowModal": _cache[6] || (_cache[6] = function ($event) { return ((isShowPhraseModal).value = $event); }),
                    "selected-phrase-type": phraseType.value,
                    "onUpdate:selectedPhraseType": _cache[7] || (_cache[7] = function ($event) { return ((phraseType).value = $event); }),
                    "selected-phrase": selectedPhrase.value,
                    "onUpdate:selectedPhrase": _cache[8] || (_cache[8] = function ($event) { return ((selectedPhrase).value = $event); }),
                    onConfirmSelect: handlePhraseConfirm
                }, null, 8, ["is-show-modal", "selected-phrase-type", "selected-phrase"])
            ], 64));
        };
    }
});
